import { Component, OnInit, Input } from '@angular/core';
import { DemandeResurmeDTO } from 'src/app/suivi-portefeuille/core/model/resurme/demande-resurme-dto';
import { Router, ActivatedRoute, Params } from '@angular/router';
import { FormBuilder } from '@angular/forms';
import { RequestService } from 'src/app/parametrage/core/service/request.service';

@Component({
  selector: 'app-info-client',
  templateUrl: './info-client.component.html',
  styleUrls: ['./info-client.component.scss']
})
export class InfoClientComponent implements OnInit {

  @Input() numDossier: String;

  demandeResurmeDTO: DemandeResurmeDTO;

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    private _requestService: RequestService
  ) { }

  ngOnInit() {

    this.findResurmerDemandeByRefCoreBanking(this.numDossier);

  }

  findResurmerDemandeByRefCoreBanking(numDossier) {
    this._requestService
      .findResurmerDemandeByRefCoreBanking(numDossier)
      .subscribe(
        (data) => {
          this.demandeResurmeDTO = data;
        },
        (error) => {
          console.log(error);
        }
      );
  }


  
}
